import { $remark } from '@milkdown/kit/utils';
import { remarkSingleCard as sharedRemarkSingleCard } from '@platform/markdown';

/**
 * Milkdown wrapper for the shared remarkSingleCard plugin.
 *
 * This wraps our shared remark plugin (used by SlackishMarkdown for view mode)
 * so it can be used in the Milkdown editor context. This ensures perfect parity
 * between view and edit modes.
 *
 * The shared plugin handles:
 * - Emoji detection: ✅ (win), ⚠️ (warning), 💬 (quote), 🗒️ (note)
 * - Transforms emoji-prefixed blockquotes into typed card nodes
 * - Skips blockquotes inside grouped-cards (avoids double-transformation)
 * - Preserves non-card blockquotes as standard markdown
 *
 * @see web/src/markdown/remarkSingleCard.ts for the core implementation
 */
export const singleCardRemark = $remark('single_card_remark', () => {
  console.log('[singleCardRemark] factory registered (using shared plugin)');

  // The shared plugin is an attacher (returns a transformer)
  // Milkdown expects: factory → attacher → transformer
  // So we need to return the attacher directly
  return sharedRemarkSingleCard;
});
